module.exports = __webpack_public_path__ + "static/media/hpb.44d324f8.svg";